<template>
    <el-date-picker
    v-model="myValue"
    type="datetime"
    placeholder="选择日期时间"
    @change="timeChange"
    value-format="timestamp"
    size="small"
    >
  </el-date-picker>

</template>
<script>
export default {
  props:{
    value:{type:[Number,String]},
    catename:{type:String,default:null}
  },
  watch: {
    
      value(newVal) {
       
       if(newVal){
        this.myValue = newVal*1000>0?newVal*1000+ '':''
       }else{
        this.myValue = null
       }
      console.log( this.myValue )
      },
   
    myValue(newVal) {
      // console.log('newVal',newVal)
      this.$emit('input', newVal/1000+'')
    }
  },
    data() {
      return {
        myValue:this.value*1000>0?this.value*1000:''
      };
    },
    methods: {
        timeChange(data){
            this.$emit('click',data,this.catename)
        }
    },
    created() {
   
      // if(this.value){
      //   this.myValue = this.value*1000>0?this.value*1000:''
      // }
    },
  }
</script>

<style scoped>
  
</style>